<template>
    <footer id="nav" class="mt-20 py-9 bg-theme-blue grid grid-cols-3 gap-4">
        <div class="col-span-3 my-8 flex flex-col justify-items-center
                    md:col-span-1 ">
            <div class="flex-1 flex flex-col justify-evenly items-center">
                <img class="w-56 py-4" src="@/assets/images/logo-footer-rdb.png" alt="">
                <img class="w-56 py-4" src="@/assets/images/logo-footer-vlc.png" alt="">
                <img class="w-56 py-4" src="@/assets/images/logo-footer-new.png" alt="">            
            </div>
        </div>
        <div class="col-span-3 text-center
                    md:col-span-1">
            <div class="footer-title my-8 text-white font-semibold text-xl uppercase">Menú</div>
            <ul>
                    <li class="text-sm text-white uppercase my-4 tracking-wide hover:text-theme-sky "><router-link to="/" active-link="activo">
                        Inicio</router-link></li>
                    <li class="text-sm text-white uppercase my-4 tracking-wide hover:text-theme-sky "><router-link to="/bibliotecas" active-link="activo">
                        Red de Bibliotecas</router-link></li>
                    <li class="text-sm text-white uppercase my-4 tracking-wide hover:text-theme-sky "><router-link to="/catalogo">
                        Catálogo Colectivo</router-link></li>
                    <li class="text-sm text-white uppercase my-4 tracking-wide hover:text-theme-sky "><router-link to="/autores">
                        Autores Locales</router-link></li>
                    <li class="text-sm text-white uppercase my-4 tracking-wide hover:text-theme-sky "><router-link to="/libros-circulan">
                        Los libros circulan</router-link></li>
                    <li class="text-sm text-white uppercase my-4 tracking-wide hover:text-theme-sky "><router-link to="/catalogos-digitales">
                        Recursos Digitales</router-link></li>                
                    <li class="text-sm text-white uppercase my-4 tracking-wide hover:text-theme-sky "><router-link to="/novedades">
                        {{ tituloNovedades }}  </router-link></li>                
            </ul>
        </div>
        <div class="col-span-3 
                    md:col-span-1">
            <div class="footer-title my-8 text-white font-semibold text-xl uppercase text-center">Contactenos</div>
            <ul class="flex justify-center items-center mb-20
                       md:flex-col md:items-start md:ml-10  ">
                <a :href="`https://www.facebook.com/vicentelopezcultura`" target="_blank">
                <li class="flex items-center text-white text-xl mt-6 tracking-wider">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 mr-3" viewBox="0 0 24 24"><path fill="#fff" d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"/></svg>
                    <span class="hidden
                                 md:block">/vicentelopezcultura</span>
                </li></a>

                <a :href="`https://www.instagram.com/vicentelopezcultura`" target="_blank">
                <li class="flex items-center text-white text-xl mt-6 tracking-wider"><svg xmlns="http://www.w3.org/2000/svg" class="w-8 mr-3" viewBox="0 0 24 24"><path fill="#fff" d="M17.25 7.288v1.269c0 .297-.241.539-.538.539h-1.269c-.299 0-.538-.242-.538-.539v-1.269c0-.297.239-.538.538-.538h1.269c.297 0 .538.241.538.538zm-5.25 7.403c1.486 0 2.693-1.205 2.693-2.692s-1.207-2.69-2.693-2.69c-1.487 0-2.691 1.204-2.691 2.691s1.204 2.691 2.691 2.691zm4.261-3.291c.028.196.046.396.046.599 0 2.38-1.928 4.308-4.307 4.308s-4.307-1.928-4.307-4.307c0-.204.018-.403.046-.599.027-.194.066-.383.118-.567h-1.107v5.879c0 .297.241.538.538.538h9.424c.297 0 .538-.241.538-.538v-5.879h-1.107c.05.184.09.373.118.566zm7.739.6c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-5-5.385c0-.892-.723-1.615-1.615-1.615h-10.77c-.892 0-1.615.723-1.615 1.615v10.769c0 .893.723 1.616 1.615 1.616h10.77c.892 0 1.615-.723 1.615-1.616v-10.769z"/></svg>
                    <span class="hidden
                                 md:block">/vicentelopezcultura</span></li></a>

                <a :href="`mailto:red.bibliotecas@vicentelopez.gov.ar`" target="_blank">
                <li class="flex items-center text-white text-xl mt-6 tracking-wider"><svg xmlns="http://www.w3.org/2000/svg" class="w-8 mr-3" viewBox="0 0 24 24"><path fill="#fff" d="M12 .02c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.99 6.98l-6.99 5.666-6.991-5.666h13.981zm.01 10h-14v-8.505l7 5.673 7-5.672v8.504z"/></svg>
                    <span class="hidden
                                 md:block">red.bibliotecas@vicentelopez.gov.ar</span>
                </li></a>
                
                <li class="flex items-center text-white text-xl mt-6 tracking-wider">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 mr-3" viewBox="0 0 24 24"><path fill="#fff" d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3.445 17.827c-3.684 1.684-9.401-9.43-5.8-11.308l1.053-.519 1.746 3.409-1.042.513c-1.095.587 1.185 5.04 2.305 4.497l1.032-.505 1.76 3.397-1.054.516z"/></svg>
                    <span class="hidden
                                 md:block">011 4513 1957</span>
                </li>
            </ul>
        </div>


    </footer>
    <div class="bg-theme-sky text-center py-3 text-gray-50 text-sm">
        <a>&copy; 2023 - Diseño y Desarrollo por onMedia</a>
    </div>      
</template>
<script>
import { inject } from 'vue';

export default ({
    name: 'Footer',
    setup() {
        const tituloNovedades = inject('tituloNovedades', 'Novedades');

        const footer = require('@/assets/images/footer/footer.jpg')
       
        return{footer, tituloNovedades}
        
    },
})
</script>
